/**
 * Copyright Mántum All Rights Reserved.
 */
import type { Constraint, Locale, Validation, Formatter } from '@mantum/kanela';

export type PropTypes<T> = {
    advanced?: {
        locale?: Locale;
    };
    disabled?: boolean;
    error?: boolean;
    format?: T;
    name?: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange?: (name?: string, value?: unknown) => void;
    optional?: boolean;
    placeholder?: string;
    testid?: string;
    validation?: {
        date?: Constraint;
    } & Validation;
    value?: string | Date | 'now' | number;
    message?: string;
};

export const getValue = <T>(
    formatter: Formatter<T>,
    format: T,
    value?: string | Date | 'now' | number
) => {
    // prettier-ignore
    const timestamp = typeof value === 'number' 
        ? new Date(value) 
        : null;

    const current =
        typeof value === 'string' && value !== 'now'
            ? formatter.from(value)
            : timestamp;

    // prettier-ignore
    const now = value === 'now' 
        ? new window.Date() 
        : current;

    // prettier-ignore
    const date = value instanceof Date 
        ? value 
        : now;

    // prettier-ignore
    const formatted = date 
        ? formatter.format(date, format) 
        : '';

    return {
        date: date ?? new window.Date(),
        value: formatted ? formatted : ''
    };
};
